export default {"src":"/education/_next/static/media/certificate-school.a6457972.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};